

<div class="info-box background-primary">
	<div class="title"></div>
    <div class="text"  >
        Anyone who is something, and is something essentially, <br> posseses “eo
ipso” the claim to be recognized for exactly this special thing,<br> and
for nothing more or less.      <i style="padding-left:20px;">Nietzsche</i>

	</div>

</div>
